<template>
    <div class="k-avatar-letter__wrapper">
        <div :class="['k-avatar-letter__label', {'c-pointer k-avatar-letter__editing': isEditing}]">
            <img
                v-if="avatar"
                class="k-avatar-letter__img"
                :src="avatar"
                alt="avatar"
            />
            <div
                v-else
                class="k-avatar-letter__letter"
                :style="{
                    width: `${size}px `,
                    height: `${size}px `,
                    'font-size': `${size - 16}px`,
                    'line-height': `${size}px`
                }"
            >{{ avatarLetter }}</div>
            <slot></slot>
            <slot name="edit" class="k-avatar-slot"></slot>
        </div>
    </div>
</template>

<script>
  export default {
    name: "TheAvatarLetter",
    props: {
      avatar: String,
      title: String,
      isEditing: {
        type: Boolean,
        default: false
      },
      size: {
        type: Number,
        default: 32
      }
    },
    data() {
      return {
        imageId: Math.random()
      };
    },
    computed: {
      avatarLetter() {
        if(this.title) {
          return this.title[0];
        }
        return 'A';
      }
    }
  }
</script>

<style lang="scss" scoped>
    .k-avatar-letter__wrapper {
        width: fit-content;
    }

    .k-avatar-letter__img {
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        text-align: center;
    }

    .k-avatar-letter__letter {
        @extend .k-avatar-letter__img;

        text-transform: uppercase;
        line-height: 1;
        background: rgba(246, 140, 30, 0.15);
        color: #F68C1E;
        font-size: 24px;
    }

    .k-avatar-letter__img {
        border-radius: 4px;
        max-height: 120px;
        max-width: 100%;
    }

    .k-avatar-letter__label {
        position: relative;
    }

    .k-avatar-letter__editing {
      min-height: 120px;
      display: flex;
    }
</style>
